import { render, staticRenderFns } from "./LectureExtraMaterialCreate.vue?vue&type=template&id=46620d5f&scoped=true&"
import script from "./LectureExtraMaterialCreate.vue?vue&type=script&lang=ts&"
export * from "./LectureExtraMaterialCreate.vue?vue&type=script&lang=ts&"
import style0 from "./LectureExtraMaterialCreate.vue?vue&type=style&index=0&id=46620d5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46620d5f",
  null
  
)

export default component.exports